import {
  AppBar,
  Button,
  IconButton,
  Stack,
  Tooltip,
  useMediaQuery,
  useScrollTrigger,
} from "@mui/material";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { routes } from "../../routes/index";
import RouteItem from "../../routes/index";
import { Helmet } from "react-helmet";
import SubMenu from "../../components/SubMenu";

interface InputProps {
  currentPath: string | null;
  parentPath: string;
  setCurrentPath: Function;
  setParentPath: Function;
}

const NavBar = ({
  currentPath,
  parentPath,
  setCurrentPath,
  setParentPath,
}: InputProps) => {
  const [description, setDescription] = useState("");
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const scrollTrigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    const scrollingDown = prevScrollPos < currentScrollPos;
    setPrevScrollPos(currentScrollPos);
    return scrollingDown;
  };
  const navigate = useNavigate();
  const [mobileHamburgerState, setMobileHamburgerState] =
    useState<boolean>(false);
  const matches = useMediaQuery("(max-width:970px)");

  const checkMobileNav = () => {
    if (!matches) {
      setMobileHamburgerState(true);
    } else {
      setMobileHamburgerState(false);
    }
  };
  useEffect(() => {
    for (let i of routes) {
      if (i?.description && i?.path === parentPath) {
        setDescription(i?.description);
      }
    }
  }, [parentPath]);
  useEffect(() => {
    handleScroll();
  }, [scrollTrigger]);
  useEffect(() => {
    checkMobileNav();
  }, [matches]);

  return (
    <AppBar
      sx={{
        position: "relative",
        width: "100%",
        backgroundColor: "background.paper",
        margin: "0 !important",
        overflow: { xs: "none", md: "auto", lg: "none" },
      }}
      elevation={0}
      key={0}
    >
      <Helmet>
        <title>
          {parentPath === "/"
            ? "St. Xaviers Pune"
            : parentPath?.substring(1)?.includes("-")
            ? parentPath
                ?.substring(1)
                ?.split("-")
                ?.join(" ")
                .slice(0, 1)
                .toUpperCase() +
              parentPath?.substring(1)?.split("-")?.join(" ").substring(1)
            : parentPath?.substring(1).slice(0, 1).toUpperCase() +
              parentPath?.substring(1).substring(1)}
        </title>
        <meta name="description" content={description} />
        <meta
          name="keywords"
          content="St. Xavier's Pune,  Xavier's Pune, Xavier Pune, St. Xavier Pune, Xavier Pune School, St. Xavier's Pune School Website"
        />
      </Helmet>
      <Stack
        key={parentPath}
        direction={matches ? "column" : "row"}
        alignItems={matches ? "flex-end" : "center"}
        justifyContent="center"
        spacing={1}
        sx={{
          width: "100%",
        }}
      >
        {matches && (
          <IconButton
            sx={{
              color: "customColors.clr2",
            }}
            onClick={() => {
              setMobileHamburgerState(!mobileHamburgerState);
            }}
          >
            {mobileHamburgerState ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        )}

        {mobileHamburgerState &&
          routes.map((menu: RouteItem, i: number) =>
            menu?.subRoutes && menu?.key !== "router-policies" ? (
              <motion.span
                initial={{ scale: 0 }}
                whileInView={{
                  scale: 1,
                  transition: { duration: 0.5, delay: i * 0.1 },
                }}
              >
                <Tooltip title={menu.tooltip} key={menu.key}>
                  <SubMenu
                    key={menu.key}
                    menuItem={menu}
                    parentPath={parentPath}
                    currentPath={currentPath}
                    setParentPath={setParentPath}
                    setCurrentPath={setCurrentPath}
                    setMobileHamburgerState={setMobileHamburgerState}
                  />
                </Tooltip>
              </motion.span>
            ) : (
              <>
                {menu.key !== "router-error" &&
                menu.key !== "router-school-manager" &&
                menu?.key !== "router-policies" ? (
                  <Tooltip title={menu.tooltip} key={menu.key}>
                    <Button
                      key={menu.key}
                      size="small"
                      component={motion.div}
                      initial={{ scale: 0 }}
                      whileInView={{
                        scale: 1,
                        transition: { duration: 0.5, delay: i * 0.1 },
                      }}
                      sx={{
                        textWrap: "nowrap",
                        fontFamily: "inherit",
                        color:
                          parentPath === menu.path
                            ? "customColors.clr1"
                            : "text.secondary",
                        bgcolor:
                          parentPath === menu.path ? "customColors.clr2" : "",
                        ":hover": {
                          bgcolor: "customColors.clr2", // theme.palette.primary.main
                          color: "customColors.clr1",
                        },
                      }}
                      onClick={() => {
                        checkMobileNav();
                        navigate(menu.path);
                        setParentPath(menu.path);
                      }}
                    >
                      {menu.title}
                    </Button>
                  </Tooltip>
                ) : (
                  ""
                )}
              </>
            )
          )}
      </Stack>
    </AppBar>
  );
};

export default NavBar;
